import React, { useContext, useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import CalendarContext from "components/Calendar/CalendarContext";
import { useDispatch } from "react-redux";
import { notifyError } from "redux/actions/Notifications";
import Button from "components/common_components/Button";
import LoadingPage from "components/common_components/LoadingPage";
import AppContext from "AppContext";
import GoogleCalendarIcon from "assets/icons/i-google-calendar.svg?react";
// import { Tenant } from "utils/tenants";

const GoogleCalendarLogin = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const { onAuthSuccess } = useContext(CalendarContext);

    const {
        api: { Google },
    } = useContext(AppContext);

    const processError = (error) => {
        console.error(error?.response);
        const apiResponseError = error?.response?.data?.error?.message;
        const internalError = error?.message;
        const errMsg = apiResponseError || internalError || "Something went wrong.";
        dispatch(notifyError(errMsg));
    };

    const initGoogleAuth = useGoogleLogin({
        flow: "auth-code",
        onSuccess: async (response) => {
            try {
                const googleAuthResponse = await Google.Auth.authenticate(response.code);
                onAuthSuccess(googleAuthResponse.data);
            } catch (error) {
                processError(error);
            } finally {
                setLoading(false);
            }
        },
        onError: (error) => {
            console.log("Login Failed:", error);
            dispatch(notifyError("Google login failed"));
        },
        scope: "https://www.googleapis.com/auth/calendar",
        error_callback: (error) => {
            setLoading(false);
        },
        // hint: String(user.email).endsWith(Tenant.getGoogleAuthHostedDomain()) ? user.email : undefined,
        // hosted_domain: Tenant.getGoogleAuthHostedDomain(),
    });

    const doLogin = () => {
        setLoading(true);
        initGoogleAuth();
    };

    return (
        <div className="master-calendar-login">
            <div className="disclaimer">
                <p>Your Master Calendar is powered by Google. Please log in with your Google account.</p>
            </div>
            {loading ? (
                <LoadingPage />
            ) : (
                <Button primary outline onClick={doLogin}>
                    <GoogleCalendarIcon style={{ height: "1.5rem", width: "1.5rem", marginRight: "0.5rem" }} />
                    <span>Login with Google</span>
                </Button>
            )}
        </div>
    );
};

export default GoogleCalendarLogin;
